import React, { useState, useContext, useEffect } from 'react';

type ParentsContextT = {
  parents: string[];
};

const ParentsContext = React.createContext<ParentsContextT | undefined>(
  undefined
);

export const ParentsProvider = ({
  children,
  initialParents,
}: {
  children: React.ReactNode;
  initialParents: string[];
}) => {
  const [parents, setParents] = useState<string[]>([]);

  useEffect(() => {
    setParents([...initialParents]);
  }, [initialParents]);

  return (
    <ParentsContext.Provider
      value={{
        parents,
      }}
    >
      {children}
    </ParentsContext.Provider>
  );
};

export const useParents = (): ParentsContextT => {
  const value = useContext(ParentsContext);

  if (value === undefined)
    throw new Error('The Parents context had not been initialized.');

  return value;
};
